'use strict';

import angular from 'angular';

import listDirective from './list';

const MODULE_NAME = 'daupler.incidents.pagination';

var app = angular.module(MODULE_NAME, [
]);
app.directive('incidentListPagination', listDirective);

export default MODULE_NAME;
